import { MouseEventHandler } from 'react';

import classNames from 'classnames';
import { motion } from 'framer-motion';

interface IProps {
  isChecked: boolean;
  onChange: MouseEventHandler<HTMLButtonElement>;
  isDisabled: boolean;
}

export const Toggle = ({
  isChecked,
  onChange: handleOnChange,
  isDisabled,
}: IProps) => {
  return (
    <button disabled={isDisabled} onClick={handleOnChange}>
      <div
        className={classNames(
          'w-[51px] flex-row rounded-full border border-black/5 bg-culturedPearlGrey p-[1px] dark:bg-eclipse',
          {
            ['!bg-successGreen']: isChecked && !isDisabled,
          },
        )}
      >
        <motion.div
          className={classNames(
            'h-[25px] w-[25px] rounded-full border shadow-sm',
            {
              ['cursor-pointer border-grey bg-white']: !isDisabled,
              ['cursor-not-allowed border-grey/30 bg-white/30']: isDisabled,
            },
          )}
          animate={{
            x: isChecked ? 'calc(100% - 2px)' : 0,
          }}
        />
      </div>
    </button>
  );
};
